import { useCrudOperation } from "@/composables";

const { update } = useCrudOperation();

export default {
  SET_ALL_SKILLS(state, payload) {
    state.allSkills = {
      items: payload.data,
      totalItems: payload.count,
    };
  },
  UPDATE_ADMIN(state, payload) {
    update(state.allAdmins.items, payload);
  },
  SET_PENDING_USERS_NUM(state, payload) {
    state.pendingUsers = {
      items: payload.data,
      totalItems: payload.count,
    };
  },

  UPDATE_SKILL(state, payload) {
    update(state.allSkills.items, payload.data[0]);
  },
  SET_ALL_ADMINS(state, payload) {
    state.allAdmins = {
      items: payload.data,
      totalItems: payload.count,
    };
  },
  SET_ADMINS(state, data) {
    state.admins = data;
  },
  SET_CREATE_ADMIN(state, data) {
    state.admins = data;
  },

  SET_GET_COMPANIES(state, data) {
    state.companies = data;
  },

  SET_GET_CANDIDATES(state, data) {
    state.candidates = data;
  },

  SET_GET_EDUCATIONS(state, data) {
    state.educations = data;
  },

  UPDATE_COMPANY(state, payload) {
    update(state.company.data, payload?.data[0]);
  },
  UPDATE_INSIGHT(state, payload) {
    update(state.allInsights.items, payload.data[0]);
  },
  UPDATE_JOBPOST(state, data) {
    update(state.allJobs.items, data);
  },

  SET__ALL__COMPANIES(state, payload) {
    state.company = {
      items: payload.data,
      totalItems: payload.count,
    };
  },

  SET_ALL_JOBS(state, payload) {
    state.allJobs = {
      items: payload.data,
      totalItems: payload.count,
    };
  },

  SET_ALL_INSIGHTS(state, payload) {
    const newArray = payload.data.map((item) => ({
      company_name: item?.company?.name || '',
      ...item,
    }));
    state.allInsights = {
      items: newArray,
      totalItems: payload.count,
    };
  },
  SET_CANDIDATE_APPLIED_JOBS(state, payload) {
    state.allCandidateJobApplied = {
      items: payload.data,
      totalItems: payload.count,
    };
  },

  SET_PENDING_USERS(state, payload) {
    state.pendingUsers = {
      items: payload.data,
      totalItems: payload.count,
    };
  }

};
